module.exports = __webpack_public_path__ + "static/media/no-feedback.2875dcb4.svg";